import React from 'react';

class ProjectHome extends React.Component {

    render() {
        return (
            <div>Some info and overview about the project...</div>
        )
    }
}

export default ProjectHome;



// WEBPACK FOOTER //
// ./src/components/project/ProjectHome.js